import axiosInstance from "./axiosInstance";

const COMPONENT = "BankRequests: ";
export function getBanks() {

    return new Promise((resolve, reject) => {

        axiosInstance.get("/banks")
            .then(res => {
                console.log(`${COMPONENT}${JSON.stringify(res.data)}`);
                resolve(res.data);
            })
            .catch(e => {
                console.error(`${COMPONENT}${e}`);
                reject(e);
            });

    });

}